// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags_tags__1s0e8","pink":"tags_pink__1htII","blue":"tags_blue__2Qrs5","black":"tags_black__wAt-S","white":"tags_white__3iYOT"};